import { Collection, VerticalAlignment } from "@mcleod/core";
import { ChangeListener, Panel, PanelProps } from "../..";
import { ListenerListDef } from "../../base/ListenerListDef";
import { DatePicker } from "./DatePicker";
import { DateTimePickerChangeEvent, DateTimePickerChangeListener } from "./DateTimePickerChangeEvent";
import { TimePicker } from "./TimePicker";

export interface DateTimePickerProps extends PanelProps {
  value: Date;
}

const _changeListenerDef: ListenerListDef = { listName: "_changeListeners" };

export class DateTimePicker extends Panel {
  datePicker: DatePicker;
  timePicker: TimePicker;
  _value: Date;

  constructor(props?: Partial<DateTimePickerProps>) {
    super({ verticalAlign: VerticalAlignment.TOP, ...props });
    this.datePicker = new DatePicker({...props});
    this.timePicker = new TimePicker(props);
    this.datePicker.rowBreak = false;
    this.add(this.datePicker, this.timePicker);
    this._value = props?.value || new Date();
    this.datePicker.addChangeListener(event => this.dateChanged(event));
    this.timePicker.addChangeListener(event => this.timeChanged(event));
  }

  dateChanged(event: DateTimePickerChangeEvent) {
    const oldValue = this._value;
    if (this._value == null)
      this._value = new Date();
    this._value.setFullYear(event.newValue.getFullYear(), event.newValue.getMonth(), event.newValue.getDate());
    this.fireListeners(_changeListenerDef, new DateTimePickerChangeEvent(this, oldValue, this._value, event.domEvent, event.changePart));
  }

  timeChanged(event: DateTimePickerChangeEvent) {
    const oldValue = this._value;
    if (this._value == null)
      this._value = new Date();
    this._value.setHours(event.newValue.getHours());
    this._value.setMinutes(event.newValue.getMinutes());
    this.fireListeners(_changeListenerDef, new DateTimePickerChangeEvent(this, oldValue, this._value, event.domEvent, event.changePart));
  }

  addChangeListener(value: DateTimePickerChangeListener): DateTimePicker {
    return <DateTimePicker>this.addEventListener(_changeListenerDef, value);
  }

  removeChangeListener(value: DateTimePickerChangeListener): DateTimePicker {
    return <DateTimePicker>this.removeEventListener(_changeListenerDef, value);
  }

  override getListenerDefs(): Collection<ListenerListDef> {
    return {...super.getListenerDefs(), "change": {..._changeListenerDef}};
  }
}
